import { z } from "zod";
import { BigDecimal, Currency } from "./common.schema.js";

export const ProductSalePriceInfo = z.object({
  productId: z.string(),
  productCode: z.string(),
  currency: Currency,
  incDutyExVatPrice: BigDecimal.nullable(),
  incDutyAndVatPrice: BigDecimal.nullable(),
  exDutyAndVatPrice: BigDecimal.nullable(),
});

export type ProductSalePriceInfo = z.infer<typeof ProductSalePriceInfo>;

export const SaveProductSalePrices = z.object({
  organisationId: z.string(),
  purchaserId: z.string().nullable(),
  salePrices: ProductSalePriceInfo.array(),
});
export type SaveProductSalePrices = z.infer<typeof SaveProductSalePrices>;

export const RemoveProductSalePrices = z.object({
  organisationId: z.string(),
  purchaserId: z.string().nullable(),
  productIds: z.string().array(),
});
export type RemoveProductSalePrices = z.infer<typeof RemoveProductSalePrices>;

export type OrgProductsWithPrices = z.infer<typeof OrgProductsWithPrices>;

export const OrgProductsWithPrices = z.object({
  productIds: z.string().array(),
});
